import React from "react";
export default function ProductPage() {
  return (
    <section className="section">
      <div className="container-gb">
        <div className="section-head split">
          <div>
            <p className="eyebrow">GrowBag</p>
            <h1 className="h-lg">Az első GrowBag még készül.</h1>
          </div>
          <p className="lead muted">Az első GrowBag termék helyi növényi alapanyagból készülő, komposztalapú termék lesz. Tervezett kiszerelések, ár és elérhetőség akkor, amikor kész az első adag.</p>
        </div>
        <div className="products">
          {[
            { kg: "5 KG", h: 69, w: 87, title: "GrowBag 5 kg", desc: "Balkonládába, cserepes növényekhez, kipróbálásra." },
            { kg: "10 KG", h: 93, w: 92, title: "GrowBag 10 kg", desc: "Magaságyásba, kisebb kerti munkákhoz." },
            { kg: "20 KG", h: 123, w: 99, title: "GrowBag 20 kg", desc: "Kerti ágyásokhoz, tavaszi indításhoz." },
            { kg: "NAGY", h: 150, w: 105, title: "GrowBag nagy kiszerelés", desc: "Nagyobb kertekhez, közösségi kertekhez." },
          ].map((p) => (
            <article key={p.title} className="product">
              <div className="product-vis"><div className="mini-bag" style={{ width: p.w, height: p.h }}><span>{p.kg}</span></div></div>
              <span className="tag">Tervezett kiszerelés</span>
              <h3>{p.title}</h3>
              <p>{p.desc}</p>
              <div className="meta"><span>Ár: később</span><span>Még nem rendelhető</span></div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
